module.exports = __webpack_public_path__ + "static/media/logo-dark-en.ecf9093a.svg";